import { AsyncStatus } from '../../libs/utils/constants/async-status';

export interface IEnrolledSkill {
    selfEnrollmentId: number;
    skillId: number;
    status: string;
    isTestCompleted: boolean;
}

export interface ISelfEnrollmentState {
    enrolledSkillsAsyncStatus:
        | typeof AsyncStatus.INITIAL
        | typeof AsyncStatus.LOADING
        | typeof AsyncStatus.SUCCESS
        | typeof AsyncStatus.FAILURE;
    enrolledSkillAsyncStatus:
        | typeof AsyncStatus.INITIAL
        | typeof AsyncStatus.LOADING
        | typeof AsyncStatus.SUCCESS
        | typeof AsyncStatus.FAILURE;
    enrolledSkills: Array<IEnrolledSkill>;
    createSelfEnrollmentAsyncStatus:
        | typeof AsyncStatus.INITIAL
        | typeof AsyncStatus.LOADING
        | typeof AsyncStatus.SUCCESS
        | typeof AsyncStatus.FAILURE;
    cancelSelfEnrollmentAsyncStatus:
        | typeof AsyncStatus.INITIAL
        | typeof AsyncStatus.LOADING
        | typeof AsyncStatus.SUCCESS
        | typeof AsyncStatus.FAILURE;
    currentEnrolledSkillId: number | null;
    eventSelfEnrolledCourseId: number | null;
}

export interface IGetEnrolledRequest {
    skillIds: number[];
}

export const SELF_ENROLLMENT_STATUS = Object.freeze({
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN-PROGRESS',
    COMPLETED: 'COMPLETED',
});

export const COURSE_CONTENT_TYPE = Object.freeze({
    CLIENT_CUSTOMIZED_SKILLS: 'Client Customized Skills',
    INSTITUTIONAL_SUPPLIED_SKILL: 'Institutional Supplied Skill',
});

export interface ICreateSelfEnrollmentRequest {
    courseId: number;
    hasCE: boolean;
}

export interface ICancelSelfEnrollmentRequest {
    selfEnrollmentId: number;
}

export const CONNECT_PLAYER_READY = 'CONNECT_PLAYER_READY';

export const SELF_ENROLLMENT_UPDATE_EVENT = 'SELF-ENROLLMENT-UPDATE';
